module.exports = __webpack_public_path__ + "static/media/exide-battery.5a958c50.svg";